import qs from "qs"; // 引入qs模块
import request from "./request";

export default {
  /**
   * 登录
   * @param username      用户名称（邮箱）
   * @param password      邮箱
   * @param grant_type    固定值
   * @param scope         固定值
   * @param client_id     固定值
   * @param client_secret 固定值
   */
  login(params) {
    return request.post("/pcs/v1/dclouduser.account.GetTokenAndLogin", params);
  },
  /**
   * 登出
   */
  logOut(params) {
    return request.post(`/pcs/v1/user.account.Logout`, params);
  },

  /**
   * 发送验证码
   */
  getValidateCode(params) {
    return request.post(`/pcs/v1/common.validcode.GetValidCode`, params);
  },

  /**
   * @func  注销账号
   * @param {*} params
   * @returns
   */
  cancellation(params) {
    return request.post(`/pcs/v1/user.account.Cancellation`, params);
  },
};
